import {BrowserRouter} from 'react-router-dom';
import { observer } from "mobx-react-lite";

import AppRouter from "./components/AppRouter";
import Header from './components/Header/Header';

const App = observer(() => {
    return (
        <BrowserRouter>
            <Header />
            <AppRouter />
        </BrowserRouter>
    );
});

export default App;